// src/mixpanel.js
import mixpanel from 'mixpanel-browser';
import { MIXPANEL_TOKEN } from '../app/constants'

// Initialize Mixpanel with your project token
mixpanel.init(MIXPANEL_TOKEN, {
  debug: process.env.NODE_ENV === 'development',
});

// Exposer mixpanel globalement pour l'intégration LiveSession
window.mixpanel = mixpanel;

export default mixpanel;
